module.exports = require('./helpers/bundle-url').getBundleURL('lSHgL') + "haus-kl.4b6095e6.gif";